import * as React from 'react';

import ApplicationChangeContainer from '../../containers/ApplicationChange';
import ApplicationChangeForSkillContainer from '../../containers/ApplicationChangeForSkill';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 受講申請変更画面OR実施申請変更画面
 * @param props
 */
const ApplicationChange: React.FC<any> = props => {
	const skillViewFlg = props.location.state.skillViewFlg;
	return (
		<>
			<MainMenu />
			<Navbar
				title={
					skillViewFlg
						? i18n.t('ApplicationChange_0017')
						: i18n.t('ApplicationChange_0018')
				}
			/>
			{!skillViewFlg && <ApplicationChangeContainer {...props} />}
			{skillViewFlg && <ApplicationChangeForSkillContainer {...props} />}
		</>
	);
};

export default ApplicationChange;



// WEBPACK FOOTER //
// ./src/pages/personal/ApplicationChange.tsx